import { render, staticRenderFns } from "./KrausSmallTooltip.vue?vue&type=template&id=6cc1b663&lang=pug&"
import script from "./KrausSmallTooltip.vue?vue&type=script&lang=js&"
export * from "./KrausSmallTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports